import { requestWithAuth } from './apiUtils';

export type ThreadListItem = {
	thread_id: string;
	title: string;
	updated_at: string;
	workflow_mode?: string | null;
};

function getThreadsBaseUrl( agentHost: string, siteId: number ): string {
	const route = window.agentConfig?.agentRoute;
	if ( ! route ) {
		console.error( 'agentConfig.agentRoute is not set — thread history URLs will be malformed.' );
	}
	return `${ agentHost.replace( /\/$/, '' ) }/${ siteId }/${ route ?? '' }/threads`;
}

export async function fetchThreads( params: {
	agentHost: string;
	siteId: number;
	workflowMode?: string;
} ): Promise< ThreadListItem[] > {
	const { agentHost, siteId, workflowMode } = params;
	const baseUrl = getThreadsBaseUrl( agentHost, siteId );
	const url = workflowMode
		? `${ baseUrl }?workflow_mode=${ encodeURIComponent( workflowMode ) }`
		: baseUrl;
	return requestWithAuth< ThreadListItem[] >( url, { method: 'GET' } );
}

export async function deleteThread( params: {
	agentHost: string;
	siteId: number;
	threadId: string;
} ): Promise< void > {
	const { agentHost, siteId, threadId } = params;
	const url = `${ getThreadsBaseUrl( agentHost, siteId ) }/${ threadId }`;
	await requestWithAuth< void >( url, { method: 'DELETE' } );
}

export async function clearThreads( params: {
	agentHost: string;
	siteId: number;
	workflowMode?: string;
} ): Promise< void > {
	const { agentHost, siteId, workflowMode } = params;
	const baseUrl = getThreadsBaseUrl( agentHost, siteId );
	const url = workflowMode
		? `${ baseUrl }?workflow_mode=${ encodeURIComponent( workflowMode ) }`
		: baseUrl;
	await requestWithAuth< void >( url, { method: 'DELETE' } );
}
